module.exports = __webpack_public_path__ + "img/tab-menu.de1aff2c.svg";